<gl-icon [name]="buttonType"></gl-icon>
<div class="content">
  <ng-content></ng-content>
</div>
